import Model from "./base/model";

class SimulationTableAdditionalService extends Model {
  resourceName() {
    return "simulation_table_additional_services";
  }

  fields() {
    return {
      modal: "",
      shipper_id: "",
      transporter_id: "",
      additional_service_id: "",

      simulation_table: "",
      additional_service: "",

      type: "",
      value: "",
      minimum_value: "",
      add_value: "",
      when_add_value: ""
    };
  }

  async search(data) {
    return this.request(
      `simulation_integra/simulation_table/additional_service/search`,
      "POST",
      {},
      data
    );
  }

}

export default new SimulationTableAdditionalService();
